import { SurfaceActionItem } from 'owa-surface-actions';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import { ComposeViewState } from 'owa-mail-compose-store';
import shouldMarkCLPLabelAsChecked from './shouldMarkCLPLabelAsChecked';
import { lazyShowJustificationModal } from 'owa-mail-protection';
import { ContextualMenuItemType } from '@fluentui/react/lib/ContextualMenu';
import {
    clpLabelDropDownLearnMoreButtonText,
    clpLabelDropDownLearnMoreButtonToolTipText,
    clpLabelCannotChangeLabelModalTitle,
    clpLabelCannotChangeLabelModalSubtext,
} from './getSensitivitySubMenu.locstring.json';
import loc from 'owa-localize';
import { confirm } from 'owa-confirm-dialog';
import setIRMData from 'owa-mail-protection/lib/actions/rms/setIRMData';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { protectionStore } from 'owa-mail-protection/lib/store/protectionStore';

export default function getSensitivitySubMenu(
    labels: CLPLabel[],
    composeViewState: ComposeViewState,
    isSmimeEnabled: boolean,
    targetWindow: Window
): SurfaceActionItem[] {
    let subMenuItems: SurfaceActionItem[] = getSubMenuItems(
        labels,
        composeViewState,
        isSmimeEnabled,
        targetWindow
    );
    let { learnMoreUrl } = protectionStore;
    if (subMenuItems) {
        if (learnMoreUrl) {
            subMenuItems = subMenuItems.concat(getLearnMoreSubMenuItem(learnMoreUrl));
        }
        return subMenuItems;
    }
    return null;
}

function getSubMenuItems(
    labels: CLPLabel[],
    composeViewState: ComposeViewState,
    isSmimeEnabled: boolean,
    targetWindow: Window
): SurfaceActionItem[] {
    if (!labels || labels.length <= 0) {
        return [];
    }
    let subMenuProps: SurfaceActionItem[] = [];
    let { protectionViewState } = composeViewState;
    let { clpViewState, IRMData } = protectionViewState;
    let isReplyOrForward = composeViewState.referenceItemId ? true : false;
    labels
        .filter(label => label.isLabelEnabled)
        .forEach(label => {
            subMenuProps.push({
                name: label.displayName,
                title: label.tooltip,
                onClick: () => {
                    if (IRMData && !IRMData.IsOwner) {
                        confirm(
                            loc(clpLabelCannotChangeLabelModalTitle), // Modal Title
                            loc(clpLabelCannotChangeLabelModalSubtext), // Subtext
                            false, // Resolve immidiately
                            { hideCancelButton: true, targetWindow } // Custom Confirmation Options
                        );
                        return;
                    }

                    removeInfoBarMessage(composeViewState, 'CLPAutoLabelAutomatic');
                    removeInfoBarMessage(composeViewState, 'CLPAutoLabelRecommended');

                    lazyShowJustificationModal.import().then(showJustificationModal => {
                        showJustificationModal(
                            label,
                            composeViewState,
                            clpViewState,
                            isReplyOrForward,
                            targetWindow
                        ).then(isLabelChanged => {
                            if (isLabelChanged && label.isEncryptingLabel) {
                                removeInfoBarMessage(composeViewState, 'irmInfoBar');
                                setIRMData(composeViewState.protectionViewState, null);
                            }
                        });
                    });
                },
                key: label.id,
                disabled: isSmimeEnabled && label.isEncryptingLabel,
                canCheck: true,
                checked: shouldMarkCLPLabelAsChecked(label, clpViewState.selectedCLPLabel),
                subMenuProps:
                    label.children &&
                    label.children.filter(childLabel => childLabel.isLabelEnabled).length > 0
                        ? {
                              items: getSubMenuItems(
                                  label.children,
                                  composeViewState,
                                  isSmimeEnabled,
                                  targetWindow
                              ),
                          }
                        : null,
            });
        });
    return subMenuProps;
}

function getLearnMoreSubMenuItem(learnMoreUrl: string): SurfaceActionItem[] {
    return [
        {
            key: 'divider',
            itemType: ContextualMenuItemType.Divider,
        },
        {
            name: loc(clpLabelDropDownLearnMoreButtonText),
            title: loc(clpLabelDropDownLearnMoreButtonToolTipText),
            onClick: () => {
                window.open(learnMoreUrl, '_blank');
            },
            key: 'LearnMore',
            canCheck: false,
            checked: null,
        },
    ];
}
